import {Text} from '#component/base';

import {SubscriptionManager} from './SubscriptionManager';
import {SubscriptionManagerProvider} from './SubscriptionManager/SubscriptionManagerContext';

import {boxContainer, headerContainer} from './ManagePlan.css';

const ManagePlanTab = () => {
  return (
    <SubscriptionManagerProvider>
      <div className={boxContainer}>
        <div className={headerContainer}>
          <Text as="h2" variant="heading2" color="burgundy">
            Manage My Plan
          </Text>
        </div>
        <SubscriptionManager />
      </div>
    </SubscriptionManagerProvider>
  );
};
export default ManagePlanTab;
